import { useAppDispatch } from '../../../shared/lib/hooks/useAppDispatch/useAppDispatch'
import { useAppSelector } from '../../../shared/lib/hooks/useAppSelector/useAppSelector'
import { modalActions, selectModalData } from '../../../entities/Modal'
import { ChangeStateModal } from '../../../shared/ui/ChangeStateModal/ChangeStateModal'
import { resetAppSecretKey } from '../model/services/resetAppSecretKey'
import { useNavigate } from 'react-router-dom'

export const ResetAppSecretModal = () => {
	const dispatch = useAppDispatch()
	const navigate = useNavigate()
	const data = useAppSelector(selectModalData)

	const header = (
		<>
			Please confirm that you want to reset the secret key of the application
		</>
	)

	const handleConfirm = async () => {
		const result = await dispatch(resetAppSecretKey(data.applicationId))
		if (result.meta.requestStatus === 'fulfilled') {

			const appSecretKeyData = result.payload

			// @ts-ignore
			navigate(`/applications/${appSecretKeyData.applicationId}/secret`)

			setTimeout(() => {
				dispatch(modalActions.hideModal())
			})
		}

	}

	return (
		<ChangeStateModal
			handleConfirm={handleConfirm}
			headerMsg={header}
		/>
	)
}